export const testimonials = [
  {
    id: 1,
    name: "Maria Silva",
    role: "Mãe de atleta de natação",
    text: "O acompanhamento do Dr. Alberto transformou a forma como apoio minha filha. Aprendi a equilibrar incentivo e pressão, criando um ambiente muito mais saudável.",
    rating: 5
  },
  {
    id: 2,
    name: "Carlos Mendes",
    role: "Treinador de futebol",
    text: "As técnicas de mindfulness que aprendi com Dr. Alberto revolucionaram o preparo mental da minha equipe. Resultados impressionantes em campo!",
    rating: 5
  },
  {
    id: 3,
    name: "Ana Paula Costa",
    role: "Atleta de vôlei profissional",
    text: "O trabalho do Dr. Alberto me ajudou a controlar a ansiedade pré-jogo e melhorar meu foco. Meu desempenho melhorou significativamente.",
    rating: 5
  }
];

export const services = [
  {
    id: 1,
    title: "Atendimento Individual",
    description: "Sessões personalizadas de psicologia do esporte para atletas que buscam melhorar seu desempenho mental e emocional.",
    features: [
      "Sessões online via videoconferência",
      "Plano de treino mental personalizado",
      "Técnicas baseadas em neurociência cognitiva",
      "Acompanhamento contínuo"
    ]
  },
  {
    id: 2,
    title: "Consultoria para Clubes",
    description: "Trabalho especializado com equipes esportivas, implementando programas de preparação mental e desenvolvimento de atletas.",
    features: [
      "Avaliação psicológica da equipe",
      "Workshops de preparação mental",
      "Treinamento de liderança",
      "Acompanhamento em competições"
    ]
  },
  {
    id: 3,
    title: "Palestras e Workshops",
    description: "Eventos educativos sobre psicologia do esporte, mindfulness e desenvolvimento de atletas para instituições e empresas.",
    features: [
      "Conteúdo personalizado",
      "Formato presencial ou online",
      "Material didático incluso",
      "Certificado de participação"
    ]
  }
];

export const heroImages = [
  "https://images.unsplash.com/photo-1490108474814-221f6198acc5",
  "https://images.unsplash.com/photo-1612872087720-bb876e2e67d1",
  "https://images.unsplash.com/photo-1589492342521-1cc18248fffc"
];
